

















import { RouteState } from '@/types';
import { mapState } from 'vuex';
import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import { debounce } from 'lodash';
import { library } from '@fortawesome/fontawesome-svg-core';
import { faSearch } from '@fortawesome/pro-regular-svg-icons';

library.add(faSearch);

@Component({ name: 'search-box' })
export default class SearchBox extends Vue {
  @Prop({ default: false })
  disabled!: boolean;

  protected query: string = '';

  onSearchQueryChanged = debounce(this.emitSearchQuery, 500);

  emitSearchQuery() {
    this.$emit('search-query-changed', this.searchQuery);
  }

  set searchQuery(searchQuery: string) {
    this.onSearchQueryChanged();
    this.query = searchQuery;
  }

  get searchQuery() {
    return this.query;
  }
}
